import { Link } from "react-router-dom";
import { useMyPowerRanking } from "../../lib/api/leagues";

// /power-ranking — the caller's PM rating + global rank. Pre-seed the
// fantasy Worker only persists pmRating (default 1000) + rank + snapshotDate;
// W/L/D + leagues-played counters land once settle-week starts writing them.
// Until then we render just the rating and a clear empty-state message
// rather than NaN/undefined values.
export function PowerRankingRoute() {
	const ranking = useMyPowerRanking();

	return (
		<div className="mx-auto max-w-2xl space-y-6 px-4 py-8">
			<header>
				<Link
					to="/"
					className="text-xs text-[var(--color-muted)] hover:text-[var(--color-fg)]"
				>
					← Dashboard
				</Link>
				<h1 className="mt-1 text-2xl font-bold">Power Ranking</h1>
				<p className="text-sm text-[var(--color-muted)]">
					Your PM rating across every settled themed league. Each settlement
					nudges this number based on your placement.
				</p>
			</header>

			{ranking.isLoading && (
				<p className="text-sm text-[var(--color-muted)]">Loading…</p>
			)}
			{ranking.isError && (
				<p className="text-sm text-[var(--color-danger)]">
					Could not load Power Ranking.{" "}
					{ranking.error instanceof Error ? ranking.error.message : ""}
				</p>
			)}

			{ranking.data &&
				(() => {
					const rating = Number.isFinite(ranking.data.pmRating)
						? Math.round(ranking.data.pmRating)
						: 1000;
					const rank = ranking.data.rank;
					const hasSettlement = rank !== null && rank > 0;
					return (
						<>
							<section className="rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-card)] p-6 text-center">
								<p className="text-xs uppercase tracking-wide text-[var(--color-muted)]">
									Current rating
								</p>
								<p className="mt-1 text-5xl font-bold text-[var(--color-accent)]">
									{rating}
								</p>
								<p className="mt-2 text-xs text-[var(--color-muted)]">
									{hasSettlement
										? `Global rank #${rank}`
										: "Pre-seed baseline — play a settled league to start moving the needle."}
								</p>
							</section>

							<section className="rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-card)] p-4">
								<h2 className="text-sm font-semibold">
									Recent settlements
								</h2>
								<p className="mt-2 text-sm text-[var(--color-muted)]">
									{hasSettlement
										? `Last snapshot: ${ranking.data.snapshotDate ?? "—"}. Per-league deltas surface here once the fantasy Worker exposes them.`
										: "No leagues settled yet. The first round of weekly settlements lands once cron settle-week runs."}
								</p>
							</section>

							<section className="rounded-lg border border-dashed border-[var(--color-border)] p-4">
								<p className="text-sm">
									Want to climb the board?{" "}
									<Link
										to="/fantasy"
										className="font-semibold text-[var(--color-accent)] hover:underline"
									>
										Enter a weekly themed league →
									</Link>
								</p>
							</section>
						</>
					);
				})()}
		</div>
	);
}
